/**
 * Czy ilość w koszyku osiągnęła (lub przekroczyła) dostępny stan magazynowy.
 *
 * `stock` to całkowity stan magazynowy (PrestaShop `quantity_available`),
 * `quantity` to ilość już w koszyku. Gdy `stock <= 0` (nieznany lub produkt
 * z dozwoloną sprzedażą bez stanu) zwracamy false — decyzję zostawiamy backendowi.
 */
export function lineAtStockLimit(stock: number, quantity: number): boolean {
  return Number.isFinite(stock) && stock > 0 && quantity >= stock
}
